import script from "./ViewWagons.vue?vue&type=script&setup=true&lang=ts"
export * from "./ViewWagons.vue?vue&type=script&setup=true&lang=ts"

import "./ViewWagons.vue?vue&type=style&index=0&id=18f72f94&lang=scss"

const __exports__ = script;

export default __exports__